// import ECMembers from './ECMembers.tsx';
import Navbar from '../../common/Navbar/Navbar';
import Layout from '../../common/layouts/Layout';
import ECMembers from './Table/ECMembers';

const EcMembersContainer = () => {

    return (
        <Layout>
            <>
                <Navbar pageTitle="Member" />
                <ECMembers />
            </>
        </Layout>
    )
}

export default EcMembersContainer;